import {useSyncExternalStore} from 'react';
const listen=(fn:()=>void)=>{window.addEventListener('popstate',fn);return()=>window.removeEventListener('popstate',fn);};
const url=()=>window.location.href;
function useUrl(){return new URL(useSyncExternalStore(listen,url,url));}
export function usePathname(){return useUrl().pathname;}
export function useSearchParams(){return useUrl().searchParams;}
export function useParams<T extends Record<string,string|string[]> = Record<string,string>>():T;
export function useParams() {
  const params=useSearchParams();
  return {locale:params.get('locale')??'ko',projectId:params.get('projectId')??'',storyId:params.get('workId')??''};
}
function go(href:string,replace=false){
  const dest=new URL(href,window.location.origin);
  if(dest.origin!==window.location.origin) throw new Error('외부 편집 서비스로 이동하지 않습니다.');
  window.history[replace?'replaceState':'pushState']({},'',dest);
  window.dispatchEvent(new PopStateEvent('popstate'));
}
export function useRouter(){return {push:(href:string)=>go(href),replace:(href:string)=>go(href,true),back:()=>window.history.back(),forward:()=>window.history.forward(),refresh:()=>window.location.reload(),prefetch:async()=>{}};}
export function redirect(href:string):never {go(href,true);throw new Error('화면 이동 중입니다.');}
export const permanentRedirect=redirect;
export function notFound():never {throw new Error('요청한 편집 화면을 찾지 못했습니다.');}
export function useSelectedLayoutSegment(){return null;}
export function useSelectedLayoutSegments(){return [];}
